/**
 * Report constants defining available report types
 * Each constant represents a distinct business domain for reporting
 */
export const ReportTypes = {
  SALES: 'sales',
  PAYMENTS: 'payments',
  PRODUCTS: 'products',
  CANCELLATIONS: 'cancellations',
  ORDERS: 'orders',
  CASH_REGISTER: 'cash_register',
  AVERAGE_TICKET: 'average_ticket',
  DISCOUNTS: 'discounts',
  CLIENT_DATA: 'client_data',
  USERS: 'users',
} as const;

/**
 * Date range preset options for quick date selection
 */
export const DateRangePresets = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  THIS_WEEK: 'this_week',
  THIS_MONTH: 'this_month',
  THIS_YEAR: 'this_year',
  DATE_RANGE: 'date_range',
} as const;

/**
 * Input type enumeration for filter fields
 */
export const ReportInputTypes = {
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  SELECT: 'single_select',
  TIME: 'time',
  MULTISELECT: 'multiple_select',
} as const;

/**
 * Report block visualization types
 */
export const ReportBlockTypes = {
  TABLE: 'table',
  CHART: 'chart',
  SUMMARY_CARDS: 'summary_cards',
} as const;

/**
 * Column data format types for display and formatting
 */
export const ReportDataFormats = {
  LINK: 'link',
  DATE: 'date',
  TEXT: 'text',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  CURRENCY: 'currency',
  PERCENTAGE: 'percentage',
  MODULE_NAVIGATION: 'module_navigation',
} as const;

/**
 * Chart visualization types
 */
export const ReportChartTypes = {
  PIE: 'pie',
  BAR: 'bar',
  BAR_HORIZONTAL: 'bar_horizontal',
  LINE: 'line',
  AREA: 'area',
  DONUT: 'donut',
  COMPOSED: 'composed',
} as const;

/**
 * Export format enumeration
 */
export const ExportFormats = {
  EXCEL: 'excel',
} as const;

export const DateFormats = {
  YYYY_MM_DD: 'YYYY-MM-DD',
  'DD/MM/YYYY': 'DD/MM/YYYY',
} as const;
